<!-- Nothing to say beats an empty box: the section is absent entirely for a reader who
     follows nothing, or whose communities have had no recent posts. -->
@if (loading || rows.length) {
  <section class="home-section w-full m-b-50" aria-label="latest from your communities">
    <div class="section-header is-grid m-b-20">
      <fui-heading [text]="headingText" [level]="2" fontSize="f8"></fui-heading>
      <a class="section-header-link" [routerLink]="[viewAllLink]">{{ "sphere.view_all" | translate }}</a>
    </div>

    @if (loading) {
      <myp-inline-loader [loading]="loading" height="100px" spinnerName="communityFeedLoader"></myp-inline-loader>
    }

    @for (row of rows; track row.postId) {
      <div
        class="communities-feed-item"
        [style.--row-accent]="row.communityAccent || null"
        (click)="openRow(row)"
        (keyup.enter)="openRow(row)"
        tabindex="0"
        role="button"
        [attr.aria-label]="'Open ' + row.snippet"
      >
        <div class="communities-feed-avatar">
          @if (row.authorPhoto) {
            <img [src]="row.authorPhoto" [alt]="row.authorName" />
          } @else {
            <span class="community-card-avatar-initials">{{ row.authorInitials }}</span>
          }
        </div>
        <div class="communities-feed-text">
          <div class="communities-feed-meta">
            <span class="communities-feed-name">{{ row.authorName }}</span>
            <span class="communities-feed-community">{{ row.communityTitle }}</span>
            <span class="communities-feed-ago">· {{ row.agoLabel }}</span>
          </div>
          <div class="communities-feed-snippet">{{ row.snippet }}</div>
          @if (row.replyCount !== null && row.replyCount > 0) {
            <div class="communities-feed-replies">{{ row.replyCount }} {{ row.replyCount === 1 ? "reply" : "replies" }}</div>
          }
        </div>
      </div>
    }
  </section>
}
